import type { UserProfileResponsePreferencesTheme } from './userProfileResponsePreferencesTheme';

export type UserProfileResponsePreferences = {
  emailNotifications?: boolean;
  language?: string;
  theme?: UserProfileResponsePreferencesTheme;
};
